module.exports = require("js-string-escape");;